<template>
  <div id="verifytoken"></div>
</template>
<script>
import ServerResponse from "@/store/ServerResponse";

export default {
  name: "VerifyEmailUpdate",
  data() {
    return {
      message: "",
      user: "",
      token: ""
    };
  },
  methods: {
    verify() {
      this.$store
        .dispatch("auth/verifyEmailUpdate", { temporaryToken: this.$route.query.token })
        .then(() => {
          this.$router.push({ name: "dashboard" });
          this.$store.dispatch("alert/showSuccessAlert", this.$t("lang.message_user_email_update_verification_success"));
          this.$store.dispatch("auth/setEmailChangeRequested", false);
        })
        .catch(error => {
          this.$router.push({
            name: "error",
            params: { serverResponse: new ServerResponse(error.response.data)}
          });
          this.$store.dispatch("auth/setEmailChangeRequested", false);
        });
    }
  },
  mounted() {
    this.verify();
  }
};
</script>
